import { memo, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

// import { notyError, notySuccess } from '@shared/lib/notifications'

const createComponent = (WrappedComp, onLogout) => () => {
  const { t } = useTranslation(['separateHints'])

  const location = useLocation()
  const navigate = useNavigate()

  //
  //

  // notifications based on URL hash
  useEffect(() => {
    const { pathname, hash } = location

    switch (hash) {
      // //
      // // After confirmations by email
      // //
      // case '#email-confirmed':
      //   notySuccess(t('separateHints:noty.success.emailConfirmed'))

      //   navigate('/profile', { replace: true })
      //   break
      // //
      // //
      // //
      // case '#login-external-go-reg':
      //   navigate('/account-types', {
      //     state: {
      //       lockExternalFields: true,
      //     },
      //     replace: true,
      //   })
      //   break
      // case '#removeAdvisor':
      //   // nothing to do, handled in useAdvisor
      //   break
      default:
        if (hash && !pathname.includes('portfolio/creator')) {
          navigate(pathname, { replace: true })
        }
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t])

  //
  //

  return <WrappedComp onLogout={onLogout} />
}
//
//
//

const Wrapper = (WrappedComp, onLogout) => {
  const Component = createComponent(WrappedComp, onLogout)

  return <Component />
}

export const withSystem = (component) =>
  memo((props) => {
    const { onLogout } = props

    return Wrapper(component, onLogout)
  })
